require('bijou/base')

#== Description
# This widget handles the showing and hiding of an "exit popup"
#
#== Behaviour
# - only enabled for the desktop breakpoint
# - moving the mouse to within 5 pixels of the top of the browser window
#   displays the popup
# - once open, the following actions close the popup
#   - clicking a ".close" chilzd element
#   - direct click on the element (assumed to be the overlay)
#   - hitting the ESCAPE key
# - once closed, the popup will not open again

"use strict"

$.widget "chopin.exit_popup", $.bijou.base,
  options:
    enableOnBreakpoint: "desktop"

  _create: ->
    @_on @window,
      "mousemove": (e) ->
        @show() if e.clientY <= 5

    @_on
      "click": (e) ->
        @hide() if @element.is(e.target)

      "click .close": @hide

    @_on @document,
      "keydown": (e) ->
        @hide() if e.which == 27

    @breakpointEnabled()

  show: ->
    @element.fadeIn()
    EventTracker.trigger(@options.displayEvent) if (@options.displayEvent)

    @_off @window, "mousemove"

  hide: ->
    @element.fadeOut()
